import PageContainer from "../../components/dashboard/PageContainer";

const Users = () => {
  return (
    <PageContainer
      title="Users">
      {/* content here */}
    </PageContainer>
  )
};

export default Users;
